const location = {
    NOT_INITIALIZED: null,
    TIME_OUT: 5000
};

module.exports = location;
